export const partialMatch = (string: string, searchTerm: string) =>
  string.indexOf(searchTerm?.toLocaleLowerCase()) === 0;

export const exactMatch = (string: string, searchTerm: string) =>
  searchTerm?.toLowerCase()?.includes(string);
